<template>
  <v-tooltip bottom v-if="info">
    <template v-slot:activator="{ on, attrs }">
      <v-icon
          color="rgba(0, 0, 0, 0.87)"
          v-bind="attrs"
          v-on="on"
      >mdi-information-outline</v-icon>
    </template>
    <span>{{ info }}</span>
  </v-tooltip>
</template>

<script>
/**
 * Component EncounterInfoIcon.vue
 *
 * @module EncounterInfoIcon
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.4] app/src/APP_DASHBOARD/templates/components/Parts/EncounterInfoIcon.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: "EncounterInfoIcon",
  props: {
    info: {
      type: String,
      default: () => "",
    },
  },
};
</script>